import { PositionState } from "@/store/modules/crud/PositoinState";

export function SET_DATA_POSITION_SWAPPED(state: PositionState, swapped: any) {
  state.swapped = swapped;
}
